import { MODULES } from '../modules'
import type { ModuleKey } from '../routes'

/** Module identity pill — self-contained bg+fg token pair per module accent
 *  (--module-<key>-soft / --module-<key>), defined in both theme blocks.
 *  `short` renders the acronym (WAFR / FTR — the company list); `done` appends
 *  a ✓ so completion reads at a glance. */
export function ModuleBadge({
  module,
  size,
  short,
  done,
}: {
  module: ModuleKey
  size?: 'sm'
  short?: boolean
  done?: boolean
}) {
  const def = MODULES[module]
  return (
    <span
      className={`module-badge module-badge--${def.badge}${size ? ` module-badge--${size}` : ''}`}
      data-testid="module-badge"
      data-module={def.key}
      {...(done ? { 'data-done': 'true' } : {})}
      title={done ? `${def.label} — complete` : def.label}
    >
      {short ? def.shortLabel : def.label}
      {done && (
        <span className="module-badge__done" aria-label="complete">
          ✓
        </span>
      )}
    </span>
  )
}
